var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 27,
    fill: "url(#pattern0_28_375)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_28_375",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_28_375",
    transform: "scale(0.0434783 0.037037)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_28_375",
    width: 23,
    height: 27,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAbCAMAAACgNuTpAAAAAXNSR0IB2cksfwAAAPBQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ZmikqQAAAFB0Uk5TACWCQswKdPooAsD/bTrGB5n8Sjb0wQZzhPJu/uY7df3pTqWKFhxBku3cgTwYadPJVwENtvmfaO7WReC/GjLDE1MjWBnhtHw/IOy8Z2Q4xxvVnF4oAAAA/UlEQVR4nGNkgANGxn9IHASTmZHxNzZxNkbGH1jEORkZGb9gEef9xcLM+BFTXOA30KR3GOLCjN8ZGLgYX6GJi/3/BqJ4XqKJS3wGU3yv/qKISzF+gDAEGR8jicsxvoHZI8p4HybOqAgzFQT+yDDeAYqpAr3zmAEFyAGFGHUZ7zJgABVGRkPGB4o3UAQ1Gb89+Qgyn1OX8QpCWJfxONw92vwXYcIGjEeQ3G/7+DWEYcx4EMW/Dhd/gSh99v2o4QAKTgYGEeV9DGjiziDrrHYzoIszuB1l+OOwE1Pcg/GQ/fPzmOIMSi8dtjJgEfc58QVbemDwZdyONf34n0AKbgA0TTt4KFri9AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWhite);
export default __webpack_public_path__ + "static/media/StartWhite.b29817b87367fb80364f93000c410c0a.svg";
export { ForwardRef as ReactComponent };